const mutations = {
	SET_URL (state, data) {
		state.url = data
	},
	SET_HISTORY_URL (state, data) {
		state.urlHistory = data
	},
	SET_URL_UPDATE (state, data) {
		state.url = data
	},
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/urltools/mutations.js